import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram, faTiktok, faFacebook, faXTwitter } from '@fortawesome/free-brands-svg-icons'
import { ProfileDto } from '~/modules/Profile/ProfileDto'
import { emptySocials } from '~/modules/Profile/SocialsDto'
import styles from './index.module.scss'

interface SocialsProps {
  profile: ProfileDto
}

export const Socials: React.FC<SocialsProps> = ({ profile }) => {
  if (emptySocials(profile.socials)) return null

  return (
    <div className={ styles.socials__container }>
      {
        profile.socials.instagram &&
          <a
            href={ `https://www.instagram.com/${profile.socials.instagram}` }
            target='_blank'
            rel="noreferrer"
            className={ styles.socials__item }
          >
            <FontAwesomeIcon
              id="instagram-logo"
              className="fa-fw"
              icon={ faInstagram }
              size="2x"
            />
          </a>
      }

      {
        profile.socials.tiktok &&
          <a
            href={ `https://www.tiktok.com/@${profile.socials.tiktok}` }
            target='_blank'
            rel="noreferrer"
            className={ styles.socials__item }
          >
            <FontAwesomeIcon
              id="tiktok-logo"
              className="fa-fw"
              icon={ faTiktok }
              size="2x"
            />
          </a>
      }

      {
        profile.socials.facebook &&
          <a
            href={ `https://www.facebook.com/${profile.socials.facebook}` }
            target='_blank'
            rel="noreferrer"
            className={ styles.socials__item }
          >
            <FontAwesomeIcon
              id="facebook-logo"
              className="fa-fw"
              icon={ faFacebook }
              size="2x"
            />
          </a>
      }

      {
        profile.socials.twitter &&
          <a
            href={ `https://x.com/${profile.socials.twitter}` }
            target='_blank'
            rel="noreferrer"
            className={ styles.socials__item }
          >
            <FontAwesomeIcon
              id="twitter-logo"
              className="fa-fw"
              icon={ faXTwitter }
              size="2x"
            />
          </a>
      }
    </div>
  )
}
